<template>
  <data-list
    ref="dataList"
    class="content md"
    url="/activity/activity-receptionist"
    entity-name="系统管理员"
    add-btn="添加管理员"
    hide-show-detail
    :before-update="beforeUpdate"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input v-model="form.name" placeholder="输入姓名查询"></a-input>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="姓名" prop="name">
        <a-input v-model="form.name" placeholder="请输入姓名"></a-input>
      </a-form-model-item>
      <a-form-model-item label="手机号码" prop="tel">
        <a-input v-model="form.tel" placeholder="请输入手机号码"></a-input>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>

    export default {
        name: "Admin",
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    tel: [{ required: true, message: '请输入手机号码', trigger: 'blur' }]
                },
                query: "&filter[type]=1"
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.type = 1;
                }
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
